module.exports = __webpack_public_path__ + "img/quest_icon_0062_impact2.6aa23728.png";